module.exports = __webpack_public_path__ + "static/img/高4.e90489c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/smeltingEquipment/高4.jpg
// module id = x1Fs
// module chunks = 1